document.addEventListener('DOMContentLoaded', function () {
  let scrollTop = 0;

  // 1. Handle AJAX Add to Cart from product grid
  document.querySelectorAll('.ajax-add-to-cart').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      this.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          // Rebuild cart via native theme event
          document.dispatchEvent(new CustomEvent('cart:build'));

          // Trigger cart drawer open
          const cartBtn = document.querySelector('.js-drawer-open-cart');
          if (cartBtn) cartBtn.click();
        })
        .catch(err => {
          console.error('❌ Failed to add to cart:', err);
        })
        .finally(() => {
          this.classList.remove('btn--loading');
        });
    });
  });

  // 2. Fix scroll issue on drawer open/close
  // document.addEventListener('cart:build', function () {
  //   scrollTop = window.scrollY;
  //   document.documentElement.classList.add('lock-scroll');
  //   document.body.style.top = `-${scrollTop}px`;
  //   document.body.style.position = 'fixed';
  //   document.body.style.width = '100%';
  // });

  const closeButton = document.querySelector('.drawer__close-button.js-drawer-close');
  if (closeButton) {
    closeButton.addEventListener('click', function (e) {
      e.preventDefault();
      document.documentElement.classList.remove('lock-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: scrollTop, behavior: 'auto' });
    });
  }
});
